<template>
  <div v-if="!loginUrl" class="container py-0">
    <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs">
      <template v-slot:item="{ item }">
        <router-link v-if="!item.disabled" class="breadcrumbs__link" :to="item.to">
          {{ item.text }}
        </router-link>
        <template v-else>
          {{ item.text }}
        </template>
      </template>

      <template v-slot:divider>
        <v-icon color="primary">mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: 'TheBreadcrumbs',
  computed: {
    breadcrumbs() {
      const routes = {}
      const addRoute = (vueRoute) => {
        const parent = vueRoute.meta.parent ? routes[vueRoute.meta.parent] : null
        const name = vueRoute.name || vueRoute.meta.name
        if (name) {
          const route = {
            title: vueRoute.meta.title || vueRoute.name,
            name: vueRoute.name,
            parent,
          }
          routes[name] = route
        }
        if (vueRoute.children) {
          vueRoute.children.forEach((childVueRoute) => {
            addRoute(childVueRoute)
          })
        }
      }
      this.$router.options.routes.forEach((route) => {
        addRoute(route)
      })
      if (!this.$route.name) {
        return []
      }
      let route = routes[this.$route.name]
      if (!route) {
        return []
      }
      const breadcrumbs = []
      while (route) {
        if (route.name) {
          breadcrumbs.unshift({
            text: route.title,
            to: {
              name: route.name,
              params: this.$route.params,
            },
            disabled: route.name === this.$route.name,
          })
        }
        route = route.parent
      }
      return breadcrumbs
    },
    loginUrl() {
      return window.location.pathname.includes(this.$route.path) && this.$route.name === 'login'
    },
  },
}
</script>

<style lang="scss">
.breadcrumbs {
  color: rgba(33, 38, 42, 0.75);
}

.breadcrumbs .breadcrumbs__link {
  color: #21262a;

  &:hover {
    text-decoration: none;
  }
}
</style>
